export const contestVoteNamespace = (entryId) => `wotw_vote_${entryId}`;
